import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Model from 'flarum/common/Model';
import Discussion from 'flarum/common/models/Discussion';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';
import EngineVersion from '../common/models/EngineVersion';
import addEngineVersionComposer from './addEngineVersionComposer';
import addEngineVersionLabels from './addEngineVersionLabels';
import addInfiniteScroll from './addInfiniteScroll';
import addBackToTop from './addBackToTop';
import addEngineVersionControl from './addEngineVersionControl.tsx';

app.initializers.add('laya-engine-version', () => {
  // Register the EngineVersion model
  app.store.models['engine-versions'] = EngineVersion;

  // Add engineVersion relationship to Discussion model
  Discussion.prototype.engineVersion = Model.hasOne('engineVersion');

  // Add canEditEngineVersion attribute to Discussion model
  Discussion.prototype.canEditEngineVersion = Model.attribute('canEditEngineVersion');

  // Add engineVersion to discussion list requests (including "load more")
  extend(DiscussionListState.prototype, 'requestParams', function (params) {
    params.include = params.include || [];
    if (!params.include.includes('engineVersion')) {
      params.include.push('engineVersion');
    }
  });

  // Add engine version selector to composer
  addEngineVersionComposer();

  // Add engine version labels to discussion list and hero
  addEngineVersionLabels();

  // Add infinite scroll to discussion list
  addInfiniteScroll();

  // Add back to top button
  addBackToTop();

  // Add engine version control to discussion controls
  addEngineVersionControl();
});
